const LOCAL_SERVICE_WORKER_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);

type WindowLike = Pick<Window, "isSecureContext" | "location">;
type NavigatorLike = Navigator & { serviceWorker?: ServiceWorkerContainer };

type EventTargetLike = Pick<EventTarget, "addEventListener" | "removeEventListener">;

function hasServiceWorkerContext(win: WindowLike): boolean {
  return win.isSecureContext || LOCAL_SERVICE_WORKER_HOSTS.has(win.location.hostname);
}

export function getServiceWorkerContainer(
  win: WindowLike | undefined = typeof window !== "undefined" ? window : undefined,
  nav: NavigatorLike | undefined = typeof navigator !== "undefined" ? navigator : undefined,
): ServiceWorkerContainer | null {
  if (!win || !nav || !hasServiceWorkerContext(win) || !("serviceWorker" in nav)) {
    return null;
  }

  try {
    return nav.serviceWorker ?? null;
  } catch {
    return null;
  }
}

export function hasEventListenerApi(target: unknown): target is EventTargetLike {
  return (
    typeof target === "object" &&
    target !== null &&
    typeof (target as EventTargetLike).addEventListener === "function" &&
    typeof (target as EventTargetLike).removeEventListener === "function"
  );
}
